// frontend/src/hooks/useContracts.js
import { useState, useEffect } from 'react';
import api from '../utils/api';

export const useContracts = (contractIds) => {
  const [contracts, setContracts] = useState([]);
  const [contractMap, setContractMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContracts = async () => {
      if (!contractIds || contractIds.length === 0) {
        setContracts([]);
        setContractMap({});
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const response = await api.get('/api/contracts');
        const allContracts = response.data.data || [];
        
        // Convert snake_case to camelCase for each contract
        const formattedContracts = allContracts.map(contract => ({
          id: contract.id,
          name: contract.contract_name || contract.contractName || `Contract ${contract.id}`,
          organizationId: contract.organization_id || contract.organizationId,
          mainContractorOrganizationId: contract.main_contractor_organization_id || contract.mainContractorOrganizationId,
          startDate: contract.start_date || contract.startDate,
          endDate: contract.end_date || contract.endDate,
          isActive: contract.is_active ?? contract.isActive ?? true,
          createdAt: contract.created_at || contract.createdAt,
          updatedAt: contract.updated_at || contract.updatedAt,
          // Keep original data if needed
          original: contract
        }));
        
        // Filter contracts that belong to this main contractor
        const filteredContracts = formattedContracts.filter(contract => 
          contractIds.includes(contract.id)
        );
        
        setContracts(filteredContracts);
        
        // Create mapping: { contractId: contractName }
        const mapping = {};
        filteredContracts.forEach(contract => {
          mapping[contract.id] = contract.name;
        });
        setContractMap(mapping);
        
        console.log('[useContracts] Loaded contracts:', filteredContracts);
        console.log('[useContracts] Contract mapping:', mapping);
      } catch (err) {
        console.error('Error fetching contracts:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchContracts();
  }, [contractIds]);

  const getContractName = (id) => {
    return contractMap[id] || `Contract ${id}`;
  };

  return { contracts, contractMap, loading, error, getContractName };
};